export const TEST_MODE_TEMPLATES = 'Templates'
export const TEST_MODE_TEMPLATE = 'Template'
export const TEST_MODE_RULE = 'Rule'
